import cn from 'classnames';
import React from 'react';
import { getActivatedMenu, filterMenu } from '~/selectors/menu';
import Cookies from 'js-cookie';
import AppBar from '../../components/AppBar';
import css from './css.css';
import { connect } from '~/redux/connect'
import { push } from 'redux-little-router';
import {
    getActiveAppBarDialog, getActiveMenuName, getAuthResult, getCredentials,
    getCurrentModelId, getTooltipsActive
} from "~/stateGetter";
import MenuGroup from "~/components/AppBar/MenuGroup";
import UserMenu from "~/components/AppBar/UserMenu";
import { logout } from "~/rx/logout";
import identify from "~/identify";
import getConfig from "../../config";
import {pushCurrentModelHelpPath} from "~/actions/navigation_actions";
import AppBarDialog from "~/ui/AppBar/AppBarDialog";
import appBarDialogs, { appBarDialogClasses } from "~/ui/AppBar/appBarDialogs";
import {setActiveAppBarDialog} from "~/actions/ui_actions";
import {changeTooltipsActive} from "~/actions/settingsActions";
import { navigationService, isWeb } from '~/native-ui';
import { MenuStateGetter } from '~/StateGetters/MenuStateGetter';
import { UserStateGetter } from '~/StateGetters/UserStateGetter';

class AppAppBar extends React.Component {
    menuActions = {
        logout: () =>  this.props.logout(),
        goToProfile: () => this.props.push(this.props.userMeta.profile_url || ""),
        book: () => this.props.pushDialog("book"),
        mobile_login: () => this.props.pushDialog("mobile_login"),
        help: () => this.props.pushCurrentModelHelpPath(),
        _default: ({value}) => {
            if(!value) { return; }

            // console.log('_default', value);
            if(typeof value === "string" && value.match(/^http.*/g)) {
                window.open(value, '_blank').focus();
                return;
            }

            if(value in appBarDialogs) {
                if(this.props.activeAppBarDialog === value) {
                    return this.props.setActiveAppBarDialog(null);
                }

                return this.props.setActiveAppBarDialog(value);
            }

            return this.props.pushModel(value)
        },
        hideTooltips: () => this.props.changeTooltipsActive(false),
        showTooltips: () => this.props.changeTooltipsActive(true),
    };


    callMenuAction = (item) => {
        let value = item.value;
        if(!(value in this.menuActions)) {
            value = '_default';
        }

        this.props.closeDrawer()
        this.menuActions[value](item);
    };

    getUserMenuItems = () => {
        let { trans, tooltipsActive } = this.props;

        return [
            {
                tooltip: tooltipsActive ? trans('menuTooltips.profile') : "",
                className: css.profile,
                label: this.props.trans("user.profile"),
                value: 'goToProfile'
            },
            {
                icon: 'logout',
                type: 'minor',
                tooltip: tooltipsActive ? trans('menuTooltips.ownAccount') : "",
                className: css.logoutIcon,
                label: this.props.trans("logout"),
                value: 'logout'
            }
        ];
    };

    renderMenu = (name, props = {}) => {
        let { auth, activeAppBarDialog } = this.props;

        if(!auth) { return; }

        let menu = this.props.menus[name];

        if(name === identify.MENU_MINOR) {
            menu = {
                menu: [
                    ...menu.menu,
                    ...(this.props.horizontal ? this.getUserMenuItems() : [])
                ],
                horizontal: this.props.showAsHeader,
            };
        }

        menu = {
            ...menu,
            onClick: this.callMenuAction,
            activeAppBarDialog,
        }

        return <MenuGroup { ...props } { ...menu } />;
    };

    renderRight = () => {
        if(!this.props) {
            return null
        }

        return (
            this.renderMenu(identify.MENU_MINOR, {
                index: 1,
                mt: "auto",
                className: cn(css.horizontalRow, css.logoutContainer)
            })
        )
    };


    renderIconMenu = () => {
        const menu = {
            index: 100,
            userMeta: this.props.userMeta,
            menu: this.getUserMenuItems(),
            onClick: this.callMenuAction,
            activeAppBarDialog: null,
        };

        return <UserMenu { ...menu } />;
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.auth && 
                    <AppBar
                        flat
                        trans={this.props.trans}
                        companyTitle={this.props.companyTitle}
                        userMeta={this.props.userMeta}
                        showAsHeader={ this.props.showAsHeader }
                        logo={this.props.logo}
                        onClickLogo={this.props.goToHomePage}
                        title={this.props.title}
                        subTitle={this.props.subTitle}
                        className={css.bar}
                        right={this.renderRight()}
                        footer={this.renderIconMenu()}
                    >
                        {this.renderMenu(identify.MENU_MAJOR, { index: 0 })}
                    </AppBar>
                }
                
                <AppBarDialog
                    className={ appBarDialogClasses[this.props.activeAppBarDialog]}
                    activeAppBarDialog={this.props.activeAppBarDialog}
                    onClose={() =>this.props.setActiveAppBarDialog(null)}
                />
            </React.Fragment>
        )
    }
}

const RXAppBar = connect((state) => {
    let authResult = getAuthResult(state),
        modelId = getCurrentModelId(state),
        config = getConfig(),

        commonProps = {
            ...getCredentials(state),
            auth: authResult.value,
            companyTitle: config.company_title,
            title: config.title,
            logo: config.logo,
            subTitle: config.company,
            activeAppBarDialog: getActiveAppBarDialog(state),
            tooltipsActive: getTooltipsActive(state),
        };

    if(!authResult.value) {
        return {
            ...commonProps,
        };
    }

    return {
        ...commonProps,
        modelId,

        menu: new MenuStateGetter(state).getMenu(),
        userMeta: new UserStateGetter(state).getUserMeta(),
        activeMenuName: getActiveMenuName(state),
    };

}, (dispatch) => {
    return {
        push: (path) => dispatch(push(path, { forceChangeRootModel: true })),
        pushModel: (modelName) => dispatch(push("/" + modelName, { forceChangeRootModel: true })),
        pushDialog: (dialogPage) => dispatch(push({ path: "", query: { dialogPage }}, { forceChangeRootModel: false })),
        pushCurrentModelHelpPath: (modelName) => dispatch(pushCurrentModelHelpPath({ forceChangeRootModel: true })),
        goToHomePage: () => dispatch(push('')),
        logout: () => dispatch(logout()),
        setActiveAppBarDialog: (dialog) => dispatch(setActiveAppBarDialog(dialog)),
        changeTooltipsActive: (active) => dispatch(changeTooltipsActive(active))
    }
}, ({ password, username, ...props }, { pushModel, logout, ...otherDispatchers }, ownProps) => {
    let { menu, activeMenuName, activeAppBarDialog, auth, tooltipsActive, ...otherProps } = props,
        {trans} = ownProps;

    if(!auth) {
        return {
            ...props,
            ...otherDispatchers,
        }
    }

    let menuProps = {
        activeAppBarDialog,
        modelName: activeMenuName,
        tooltipsActive,
        trans,
    };

    menu = filterMenu(menu, { excluded: [tooltipsActive ? 'showTooltips' : 'hideTooltips'] });

    let major = getActivatedMenu(
            filterMenu(menu, { onlyType: identify.MENU_MAJOR }),
            menuProps
        ),

        minor = getActivatedMenu(
            filterMenu(menu, { onlyType: identify.MENU_MINOR }),
            menuProps
        );

    // const menuConfig = getConfig().menu
    const closeDrawer = () => {
        navigationService.setForceCloseDrawer(isWeb());
    }

    

    return {
        ...ownProps, ...otherProps, ...otherDispatchers,
        auth, pushModel, activeAppBarDialog,

        tooltipsActive,
        closeDrawer,
        
        menus: {
            major: {
                large: true,
                menu: major,
            },

            minor: {
                menu: minor,
            },
        },

        logout: async () => {
            await logout(username, password);
            navigationService.closeDrawer();
            Cookies.remove('token', '');
            window.Intercom?.('shutdown');
        },
    }
})(AppAppBar);

export default RXAppBar;